import React from "react";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import { useTableColumnWidths } from "./Table.context";

import styles from "./TableRow.module.css";

export interface TableRowProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export const TableRow: React.FC<TableRowProps> = ({
  children,
  className,
  onClick,
}) => {
  const { columnWidths } = useTableColumnWidths();

  return (
    <div
      className={toClassName(styles.row, className, {
        [styles.actionable]: Boolean(onClick),
      })}
      style={{ gridColumn: `1 / ${columnWidths.length + 1}` }}
      onClick={onClick}
    >
      {children}
    </div>
  );
};
